import aizhai from "./index.vue";
import aizhaiHome from "./Home.vue";

const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");
const SimpleHumidityList = () => import("./../../components/SimpleHumidityList.vue");

export default [
  {
    path: "/aizhaiIndex",
    name: "aizhaiIndex",
    component: aizhaiHome,
  },
  {
    path: "/aizhai/login",
    name: "aizhaiLogin",
    component: login,
  },
  {
    path: "/aizhai",
    name: "aizhai",
    redirect: "/aizhai",
    component: aizhai,
    children: [
      {
        path: "currentHumidityList",
        name: "currentHumidityList",
        component: SimpleHumidityList,
      },
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory,
      },
    ],
  },
];
